class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.updateVariantStatuses);
  }
  connectedCallback() { 
    this.getVariantData();
    this.updateVariantStatuses();
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".swatch-items-wrapper")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
      if (previousOptionSelected != this.lastOptionSelected) {
        optionInputs
          .find((radio) => !radio.classList.contains("disabled"))
          .click();
        this.lastOptionSelected = previousOptionSelected;
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
        input.closest(".swatch-element").style = "display:;";
      } else {
        input.classList.add("disabled");
        input.closest(".swatch-element").style = "display: none;";
      }
    });
  }
}
customElements.define("variant-radios", VariantRadios);